import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getHistoryTimelineStart,
  getHistoryTimelineSuccess,
  getHistoryTimelineFailed,
  setHistoryTimelineActiveId,
} from "../redux/getHistoryTimeline";

import { getHistoryTimelineApi } from "core/http/service/personnelInformation";
import { getHistoryTimelineItem } from "core/http/service/personnelInformation/resTypes";

function* getHistoryTimelineWork() {
  try {
    const res: getHistoryTimelineItem[] = yield call(getHistoryTimelineApi);

    yield put({
      type: getHistoryTimelineSuccess.type,
      payload: res,
    });
    if (res.length > 0) {
      yield put({
        type: setHistoryTimelineActiveId.type,
        payload: res[0].id,
      });
    }
  } catch (error: any) {
    yield put({
      type: getHistoryTimelineFailed.type,
    });
  }
}

function* watchGetHistoryTimeline() {
  yield takeLatest(getHistoryTimelineStart.type, getHistoryTimelineWork);
}

export default function* getHistoryTimelineSaga() {
  yield all([watchGetHistoryTimeline()]);
}
